import React from 'react';

const LogoutIcon = ({ width = 20, height = 21, color = '#424242', ...rest }, ref) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4983 6.33464C12.4882 4.52211 12.4078 3.54052 11.7675 2.9002C11.0353 2.16797 9.85676 2.16797 7.49974 2.16797L6.66641 2.16797C4.30938 2.16797 3.13087 2.16797 2.39864 2.9002C1.66641 3.63243 1.66641 4.81095 1.66641 7.16797L1.66641 13.8346C1.66641 16.1917 1.66641 17.3702 2.39864 18.1024C3.13087 18.8346 4.30938 18.8346 6.66641 18.8346L7.49974 18.8346C9.85676 18.8346 11.0353 18.8346 11.7675 18.1024C12.4078 17.4621 12.4882 16.4805 12.4983 14.668"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M7.5 10.5L18.3333 10.5M18.3333 10.5L15.4167 8M18.3333 10.5L15.4167 13"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(LogoutIcon);
